import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoginAttemptService {
  private MAX_LOGIN_ATTEMPTS = 3;
  private loginAttemptsKey = 'loginAttempts';
  private _loginAttempts$ = new BehaviorSubject<number>(this.getStoredAttempts());

  constructor() {}

  getLoginAttempts(): number {
    return this._loginAttempts$.value;
  }

  incrementAttempts() {
    const currentAttempts = this.getLoginAttempts();
    const newAttempts = currentAttempts + 1;
    this._loginAttempts$.next(newAttempts);
    this.storeAttempts(newAttempts);
  }

  resetAttempts() {
    this._loginAttempts$.next(0);
    sessionStorage.removeItem(this.loginAttemptsKey);
  }

  isMaxAttemptsReached(): boolean {
    return this.getLoginAttempts() >= this.MAX_LOGIN_ATTEMPTS;
  }

  private storeAttempts(attempts: number) {
    sessionStorage.setItem(this.loginAttemptsKey, attempts.toString());
  }

  private getStoredAttempts(): number {
    const storedAttempts = sessionStorage.getItem(this.loginAttemptsKey);
    return storedAttempts ? parseInt(storedAttempts, 10) : 0;
  }
}
